/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  computed,
  signal,
} from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  Subject,
  catchError,
  combineLatest,
  debounceTime,
  distinctUntilChanged,
  forkJoin,
  of,
  startWith,
  switchMap,
  takeUntil,
} from "rxjs";

// PrimeNG imports
import { ConfirmationService, MenuItem, MessageService } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DividerModule } from "primeng/divider";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { SplitButtonModule } from "primeng/splitbutton";
import { SplitterModule } from "primeng/splitter";
import { TagModule } from "primeng/tag";
import { ToastModule } from "primeng/toast";
import { ToolbarModule } from "primeng/toolbar";
import { Checkbox } from "primeng/checkbox";
import { FormsModule } from "@angular/forms";

// Our components and services
import { Subscription } from "rxjs";
import { LiveDataSubscription } from "../../../../core/models/live-data-subscription.interface";
import { LoadingService } from "../../../../core/services/loading.service";
import {
  QPilotService,
  QPilotAccessToken,
  QPilotUser,
} from "../../../../core/services/qpilot.service";
import { SessionService } from "../../../../core/services/session.service";
import {
  BulkActionsToolbarComponent,
  BulkActionEvent,
} from "../../components/bulk-actions-toolbar/bulk-actions-toolbar.component";
import { BulkDetailedResponseDialogComponent } from "../../components/bulk-detailed-response-dialog/bulk-detailed-response-dialog.component";
import { ScheduledOrderCyclesDialogComponent } from "../../components/scheduled-order-cycles-dialog/scheduled-order-cycles-dialog.component";
import { ScheduledOrdersFiltersComponent } from "../../components/scheduled-orders-filters/scheduled-orders-filters.component";
import { ListPageSkeletonComponent } from "../../../../shared/components/table-skeleton";
import { ScheduledOrdersTableComponent } from "../../components/scheduled-orders-table/scheduled-orders-table.component";
import {
  StatusSelectionDialogComponent,
  StatusSelectionResult,
} from "../../components/status-selection-dialog/status-selection-dialog.component";
import { ValidationChecksDialogComponent } from "../../components/validation-checks-dialog/validation-checks-dialog.component";
import { RescheduleDialogComponent } from "../../components/reschedule-dialog/reschedule-dialog.component";
import { ProcessingCycle } from "../../interfaces/processing-cycle.interface";
import { RescheduleDialogResult } from "../../interfaces/reschedule-dialog-data.interface";

// Interfaces
import { TooltipModule } from "primeng/tooltip";
import { SiteFull } from "../../../../core/models/site.interface";
import {
  BulkActionsResponse,
  BulkDetailedResponseDialogData,
} from "../../interfaces/bulk-actions-response.interface";
import { ScheduledOrderCounts } from "../../interfaces/scheduled-orders-counts.interface";
import {
  DEFAULT_FILTER_VALUES,
  DateRange,
  IScheduledOrdersFilterControls,
  ScheduledOrderStatus,
  ScheduledOrdersFilter,
} from "../../interfaces/scheduled-orders-filter.interface";
import {
  BulkSOActionsResponse,
  PageEvent,
  PagedResult,
  ScheduledOrderListItem,
  ProcessingCycle as ScheduledOrderProcessingCycle,
  SortEvent,
  ValidationResult,
} from "../../interfaces/scheduled-orders-list-item.interface";

/**
 * Scheduled Orders List Page Component
 * Main orchestrating component that manages filters, table, and bulk operations
 */
@Component({
  selector: "app-scheduled-orders-list",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ToastModule,
    ConfirmDialogModule,
    ButtonModule,
    DividerModule,
    ToolbarModule,
    SplitButtonModule,
    SplitterModule,
    TagModule,
    Checkbox,
    ScheduledOrdersFiltersComponent,
    ScheduledOrdersTableComponent,
    ListPageSkeletonComponent,
    BulkActionsToolbarComponent,
    TooltipModule,
  ],
  templateUrl: "./scheduled-orders-list.component.html",
  styleUrl: "./scheduled-orders-list.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ConfirmationService, DialogService],
  // Note: MessageService is NOT provided locally - we use the root instance
  // This ensures both component toast calls AND API interceptor error toasts
  // go to the same MessageService that the <p-toast> listens to
})
export class ScheduledOrdersListComponent implements OnInit, OnDestroy {
  // Input properties for embedded mode
  @Input() inputSiteId?: number;
  @Input() inputToken?: QPilotAccessToken;
  @Input() embeddedMode: boolean = false;
  @Input() hideCreateButton: boolean = false;
  @Input() hideToolbar: boolean = false;
  @Input() inputSearch?: string;

  // Reactive state using signals
  readonly currentSiteId = signal<number | null>(null);
  private readonly currentSite = signal<SiteFull | null>(null);
  readonly isShopifySite = signal<boolean>(false);

  // Data signals
  private readonly scheduledOrders =
    signal<PagedResult<ScheduledOrderListItem> | null>(null);
  private readonly orderCounts = signal<ScheduledOrderCounts | null>(null);
  private readonly selectedOrders = signal<ScheduledOrderListItem[]>([]);

  // Items 8 & 9: Cache of items counts per order (orderId -> {enabled, total})
  // Uses the Disabled flag on each item (same as Summary step)
  readonly itemsCounts = signal<
    Map<number, { enabled: number; total: number }>
  >(new Map());

  // UI state - will be initialized based on screen size
  readonly sidebarCollapsed = signal(false);
  private userManuallyCollapsed = false; // Track if user manually toggled sidebar
  readonly skipLocalStorageLoad = signal(false); // Skip localStorage load when navigating with query params

  // Loading states
  private readonly isLoading = signal(false);
  private readonly isLoadingCounts = signal(false);
  private readonly isBulkOperationLoading = signal(false);
  private readonly isInitialLoading = signal(true);

  // Form management
  filterForm: FormGroup<IScheduledOrdersFilterControls>;

  // Computed values
  readonly data = computed(() => {
    const orders = this.scheduledOrders();
    const counts = this.orderCounts();

    // If no orders data, return null
    if (!orders) return null;

    // Merge the correct total count from orderCounts into the PagedResult
    return {
      ...orders,
      TotalRecords: counts?.Total ?? orders.TotalRecords ?? 0,
    };
  });
  readonly counts = computed(() => this.orderCounts());
  readonly selectedItems = computed(() => this.selectedOrders());
  readonly loading = computed(() => this.isLoading());
  readonly loadingCounts = computed(() => this.isLoadingCounts());
  readonly bulkOperationLoading = computed(() => this.isBulkOperationLoading());
  readonly initialLoading = computed(() => this.isInitialLoading());
  readonly currentSiteData = computed(() => this.currentSite());
  readonly hasBulkSelection = computed(() => this.selectedOrders().length > 0);
  readonly hasActiveFilters = computed(() => {
    const form = this.filterForm;
    if (!form) return false;

    const values = form.value;

    // Return true if ANY filter is selected (including status)
    // This ensures the Clear All button is enabled when filters are visible
    return !!(
      values.search?.trim() ||
      values.status?.length ||
      values.processingErrorCodes?.length ||
      (Array.isArray(values.customerCreatedRange) &&
        values.customerCreatedRange.length > 0) ||
      (Array.isArray(values.scheduledOrderCreatedRange) &&
        values.scheduledOrderCreatedRange.length > 0) ||
      (Array.isArray(values.nextOccurrenceRange) &&
        values.nextOccurrenceRange.length > 0) ||
      (Array.isArray(values.lastProcessedRange) &&
        values.lastProcessedRange.length > 0)
    );
  });

  // Bulk operation menu items
  readonly bulkMenuItems = computed<MenuItem[]>(() => [
    {
      label: "Bulk Operations",
      items: [
        {
          label: `Activate Selected (${this.selectedItems().length})`,
          icon: "pi pi-play",
          command: () => this.handleBulkActivate(),
          disabled:
            this.bulkOperationLoading() || this.selectedItems().length === 0,
        },
        {
          label: `Pause Selected (${this.selectedItems().length})`,
          icon: "pi pi-pause",
          command: () => this.handleBulkPause(),
          disabled:
            this.bulkOperationLoading() || this.selectedItems().length === 0,
        },
        {
          label: `Process Selected (${this.selectedItems().length})`,
          icon: "pi pi-forward",
          command: () => this.handleBulkProcess(),
          disabled:
            this.bulkOperationLoading() || this.selectedItems().length === 0,
          separator: true,
        },
        {
          label: `Delete Selected (${this.selectedItems().length})`,
          icon: "pi pi-trash",
          command: () => this.handleBulkDelete(),
          disabled:
            this.bulkOperationLoading() || this.selectedItems().length === 0,
        },
      ],
    },
  ]);

  // Component lifecycle
  private readonly destroy$ = new Subject<void>();
  private cyclesDialogRef: DynamicDialogRef | undefined;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
    private readonly qpilotService: QPilotService,
    private readonly sessionService: SessionService,
    private readonly loadingService: LoadingService,
    private readonly messageService: MessageService,
    private readonly confirmationService: ConfirmationService,
    private readonly dialogService: DialogService,
    private readonly fb: FormBuilder,
    private readonly elementRef: ElementRef,
  ) {
    // Initialize form in constructor
    // Default status filter: show Active orders only (hide Paused, Failed, Deleted)
    this.filterForm = this.fb.group<IScheduledOrdersFilterControls>({
      siteId: this.fb.nonNullable.control(0),
      search: this.fb.control(null),
      status: this.fb.nonNullable.control(["Active"] as ScheduledOrderStatus[]),
      processingErrorCodes: this.fb.nonNullable.control([]),
      customerCreatedRange: this.fb.control(null),
      scheduledOrderCreatedRange: this.fb.control(null),
      nextOccurrenceRange: this.fb.control(null),
      lastProcessedRange: this.fb.control(null),
      page: this.fb.nonNullable.control(DEFAULT_FILTER_VALUES.page),
      pageSize: this.fb.nonNullable.control(DEFAULT_FILTER_VALUES.pageSize),
      sortBy: this.fb.control(DEFAULT_FILTER_VALUES.sortBy),
      sortDirection: this.fb.nonNullable.control(
        DEFAULT_FILTER_VALUES.sortDirection,
      ),
    });
  }

  ngOnInit(): void {
    // Handle embedded mode inputs (similar to customer-portal-settings)
    const element = this.elementRef.nativeElement as HTMLElement;

    // Get siteId from input/attribute
    const siteIdString =
      this.inputSiteId?.toString() ??
      element.getAttribute("input-site-id") ??
      element.getAttribute("inputSiteId");

    if (siteIdString) {
      const siteId = parseInt(siteIdString, 10);
      this.currentSiteId.set(siteId);
      this.filterForm.patchValue({ siteId }, { emitEvent: false });
    }

    // Get token from attribute and convert
    const tokenString =
      element.getAttribute("input-token") ?? element.getAttribute("inputToken");

    // Create inputToken from attribute if:
    // 1. We have a token string from attribute
    // 2. AND inputToken is either missing, not an object, or doesn't have valid TokenBearerAuth
    // Note: Angular Elements may bind the attribute as a raw string, so we check for proper structure
    if (
      tokenString &&
      (!this.inputToken ||
        typeof this.inputToken !== "object" ||
        !this.inputToken.TokenBearerAuth)
    ) {
      this.inputToken = {
        TokenBearerAuth: tokenString,
        TokenAuth: "",
        Id: 0,
        UserId: 0,
        CreatedUtc: new Date(),
        UpdatedUtc: new Date(),
        ExpiresUtc: new Date(),
        User: {} as QPilotUser,
        FirstLogin: 0,
      };
    }

    // Get embeddedMode from attribute
    const embeddedModeAttr = element.getAttribute("embedded-mode");
    if (embeddedModeAttr === "true") {
      this.embeddedMode = true;
    }

    // Initialize based on mode
    if (this.embeddedMode && this.inputToken && this.currentSiteId()) {
      this.initializeEmbeddedMode();
    } else if (!this.embeddedMode) {
      this.initializeStandardMode();
    }

    this.initializeResponsiveSidebar();
    this.setupWindowResizeListener();
    this.loadFiltersToForm(); // Load filters from query params OR localStorage
    this.setupQueryParamsSubscription(); // Subscribe to queryParams changes for command palette navigation
    this.setupDataSubscriptions();
    this.loadInitialData();
  }

  /**
   * Subscribe to queryParams changes to handle command palette navigation
   * This allows the search filter to be updated when navigating with ?search= params
   */
  private setupQueryParamsSubscription(): void {
    // Skip for embedded mode - it uses inputSearch instead
    if (this.embeddedMode) return;

    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        const searchParam = params["search"];
        const timestampParam = params["_t"]; // Used by command palette to force refresh

        // Only react if there's a search param AND it's different from current value
        // OR if there's a timestamp param (force refresh from command palette)
        if (searchParam !== undefined || timestampParam) {
          const currentSearch = this.filterForm.get("search")?.value;

          // If search param changed or there's a timestamp (force refresh)
          if (searchParam !== currentSearch || timestampParam) {
            this.skipLocalStorageLoad.set(true);
            this.filterForm.patchValue(
              {
                search: searchParam || "",
                status: [],
                processingErrorCodes: [],
                customerCreatedRange: null,
                scheduledOrderCreatedRange: null,
                nextOccurrenceRange: null,
                lastProcessedRange: null,
                page: 1,
              },
              { emitEvent: true }, // Emit event to trigger data reload
            );
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    // Clean up dialog reference
    if (this.cyclesDialogRef) {
      this.cyclesDialogRef.close();
    }
  }

  /**
   * Initialize for standard mode (using route parameters and session)
   */
  private initializeStandardMode(): void {
    // Get site ID from parent route parameter since we're nested under /widgets/dashboard/:siteId
    const siteId = Number(this.route.parent?.snapshot.paramMap.get("siteId"));
    if (siteId && siteId > 0) {
      this.currentSiteId.set(siteId);
      this.filterForm.patchValue({ siteId }, { emitEvent: false });

      // Fetch site data for timezone calculations (matches old QMC pattern)
      const accessToken = this.getAccessToken();
      if (accessToken) {
        this.fetchSiteData(siteId, accessToken);
      }
    } else {
      console.warn("No siteId found in route parameters");
    }
  }

  /**
   * Initialize for embedded mode (using input properties)
   */
  private initializeEmbeddedMode(): void {
    const siteId = this.currentSiteId();
    if (siteId && this.inputToken) {
      // Fetch site data using the provided token
      this.fetchSiteData(siteId, this.inputToken);
    } else {
      console.warn("Embedded mode: missing siteId or token");
    }
  }

  /**
   * Fetch site data for timezone calculations and Shopify detection
   */
  private fetchSiteData(
    siteId: number,
    accessToken: QPilotAccessToken | undefined,
  ): void {
    if (!accessToken) {
      console.error("No access token available");
      return;
    }
    this.qpilotService
      .getSite(siteId, accessToken)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (site) => {
          // Transform QPilot Site to full Site interface
          const fullSite: SiteFull = {
            Id: site.Id,
            Name: site.Name,
            Url: site.Url,
            IsProduction: false, // Default values for missing properties
            IsProcessingPaused: false,
            AllowRetryScheduledOrder: true,
            SupportsProcessingWindow: false,
            UtcOffset: (site as any).UtcOffset || 0, // Get UtcOffset from response or default to 0
          };
          this.currentSite.set(fullSite);

          // Check if this is a Shopify site (matches old QMC pattern)
          this.isShopifySite.set((site as any).Integration?.Name === "Shopify");
        },
        error: (error) => {
          console.error("Error fetching site data:", error);
          this.messageService.add({
            severity: "warn",
            summary: "Warning",
            detail:
              "Could not load site timezone data. Dates may display in UTC.",
            life: 5000,
          });
        },
      });
  }

  /**
   * Get access token based on mode (embedded vs standard)
   */
  getAccessToken(): QPilotAccessToken | undefined {
    // In embedded mode, use inputToken
    if (this.embeddedMode && this.inputToken) {
      return this.inputToken;
    }
    // In standard mode, use session service (convert null to undefined)
    return this.sessionService.accessToken ?? undefined;
  }

  /**
   * Setup reactive data subscriptions
   */
  private setupDataSubscriptions(): void {
    let isFirstLoad = true;

    // Watch for filter changes and load data
    this.filterForm.valueChanges
      .pipe(
        startWith(this.filterForm.value),
        debounceTime(500),
        distinctUntilChanged(),
        // Use pairwise to track previous values, but skip the reset logic since
        // pagination changes should be allowed to proceed normally
        switchMap((formValue) => {
          if (!formValue.siteId) {
            return of({ orders: null, counts: null });
          }

          // Check if any date range is incomplete - if so, don't trigger search
          const hasIncompleteDateRange = [
            formValue.customerCreatedRange,
            formValue.scheduledOrderCreatedRange,
            formValue.nextOccurrenceRange,
            formValue.lastProcessedRange,
          ].some((range) => {
            if (!range) return false; // null/undefined is fine (cleared)
            if (Array.isArray(range) && range.length === 2) {
              // Both dates must be present, or it's incomplete
              const hasStart = !!range[0];
              const hasEnd = !!range[1];
              return hasStart && !hasEnd; // incomplete if only start exists
            }
            return false;
          });

          if (hasIncompleteDateRange) {
            // Don't change loading states, don't make API call
            return of({ orders: null, counts: null, skipUpdate: true });
          }

          const accessToken = this.getAccessToken();
          if (!accessToken) {
            this.messageService.add({
              severity: "error",
              summary: "Error",
              detail: "No access token available. Please login again.",
              life: 5000,
            });
            return of({ orders: null, counts: null });
          }

          // Set loading states - initial loading only on first load
          if (isFirstLoad) {
            this.isInitialLoading.set(true);
          }
          this.isLoading.set(true);
          this.isLoadingCounts.set(true);

          const filter = this.buildFilterFromForm(formValue);

          // Load both orders and counts in parallel
          return combineLatest({
            orders: this.qpilotService.getScheduledOrders(filter, accessToken),
            counts: this.qpilotService.getScheduledOrderCounts(
              filter,
              accessToken,
            ),
          }).pipe(
            catchError((error) => {
              console.error("Error loading scheduled orders:", error);
              this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Failed to load scheduled orders. Please try again.",
                life: 5000,
              });
              return of({ orders: null, counts: null });
            }),
          );
        }),
        takeUntil(this.destroy$),
      )
      .subscribe({
        next: (result: any) => {
          // If skipUpdate flag is set, don't update state (incomplete date range)
          if (result.skipUpdate) {
            return;
          }

          const { orders, counts } = result;
          this.scheduledOrders.set(orders);
          this.orderCounts.set(counts);
          this.isLoading.set(false);
          this.isLoadingCounts.set(false);

          // Items 8 & 9: Load enabled items counts for display
          if (orders) {
            this.loadEnabledItemsCounts(orders);
          }

          // Reset initial loading state after first load
          if (isFirstLoad) {
            this.isInitialLoading.set(false);
            isFirstLoad = false;
          }

          // Clear selections when data changes
          this.selectedOrders.set([]);

          this.cdr.markForCheck();
        },
        error: (error) => {
          console.error("Subscription error:", error);
          this.isLoading.set(false);
          this.isLoadingCounts.set(false);

          // Reset initial loading state on error too
          if (isFirstLoad) {
            this.isInitialLoading.set(false);
            isFirstLoad = false;
          }

          this.cdr.markForCheck();
        },
      });
  }

  /**
   * Load initial data
   */
  private loadInitialData(): void {
    // Trigger initial load by marking form as touched
    this.filterForm.markAsDirty();
    this.filterForm.updateValueAndValidity();
  }

  /**
   * Load filters into the form
   * Priority: URL query params > localStorage
   *
   * If 'search' query param exists (e.g., from customers page):
   *   - Set search field with the query param value
   *   - Clear all other filters to defaults
   *   - Don't use localStorage
   *
   * Otherwise:
   *   - Load from localStorage as usual
   */
  private loadFiltersToForm(): void {
    // Check for search query param (used when navigating from customers page)
    // In embedded mode, check inputSearch attribute instead
    const searchParam = this.embeddedMode
      ? this.inputSearch
      : this.route.snapshot.queryParams["search"];

    if (searchParam) {
      // Search param exists - use only the search value, reset everything else
      // Also signal the child filters component to skip loading from localStorage
      this.skipLocalStorageLoad.set(true);
      this.filterForm.patchValue(
        {
          search: searchParam,
          status: [],
          processingErrorCodes: [],
          customerCreatedRange: null,
          scheduledOrderCreatedRange: null,
          nextOccurrenceRange: null,
          lastProcessedRange: null,
          page: DEFAULT_FILTER_VALUES.page,
        },
        { emitEvent: false },
      );
      return; // Don't load from localStorage
    }

    // No search param - load from localStorage as usual
    this.loadPersistedFiltersFromStorage();
  }

  /**
   * Load persisted filters from localStorage into the form
   */
  private loadPersistedFiltersFromStorage(): void {
    try {
      const saved = localStorage.getItem("scheduledOrders.filters");
      if (saved) {
        const filters = JSON.parse(saved);

        // Restore filter-specific values, not pagination/sorting
        // Default status: show Active orders only (hide Paused, Failed, Deleted)
        // NEW: Check for both falsy AND empty array - an empty array is truthy but should use default
        const statusValue =
          filters.status && filters.status.length > 0
            ? filters.status
            : (["Active"] as ScheduledOrderStatus[]);

        this.filterForm.patchValue(
          {
            search: filters.search,
            status: statusValue,
            processingErrorCodes: filters.processingErrorCodes || [],
            customerCreatedRange: this.deserializeDateRangeFromStorage(
              filters.customerCreatedRange,
            ),
            scheduledOrderCreatedRange: this.deserializeDateRangeFromStorage(
              filters.scheduledOrderCreatedRange,
            ),
            nextOccurrenceRange: this.deserializeDateRangeFromStorage(
              filters.nextOccurrenceRange,
            ),
            lastProcessedRange: this.deserializeDateRangeFromStorage(
              filters.lastProcessedRange,
            ),
          },
          { emitEvent: false },
        );
      }
    } catch (error) {
      console.warn("Failed to load persisted filters:", error);
    }
  }

  /**
   * Deserialize date range from localStorage
   */
  private deserializeDateRangeFromStorage(range: any): Date[] | null {
    if (!range || !range.startDate) return null;

    const dates: Date[] = [new Date(range.startDate)];
    if (range.endDate) {
      dates.push(new Date(range.endDate));
    }
    return dates;
  }

  /**
   * Build API filter from form values
   */
  private buildFilterFromForm(
    formValue: Partial<{
      siteId: number;
      search: string | null;
      status: string[];
      processingErrorCodes: number[];
      customerCreatedRange: Date[] | null;
      scheduledOrderCreatedRange: Date[] | null;
      nextOccurrenceRange: Date[] | null;
      lastProcessedRange: Date[] | null;
      page: number;
      pageSize: number;
      sortBy: string | null;
      sortDirection: "asc" | "desc";
    }>,
  ): ScheduledOrdersFilter {
    const filter = {
      siteId: formValue.siteId || 0,
      search: formValue.search?.trim() || undefined,
      status:
        formValue.status && formValue.status.length > 0
          ? formValue.status
          : undefined,
      processingErrorCodes:
        formValue.processingErrorCodes &&
        formValue.processingErrorCodes.length > 0
          ? formValue.processingErrorCodes
          : undefined,
      pageSize: formValue.pageSize || DEFAULT_FILTER_VALUES.pageSize,
      page: formValue.page || DEFAULT_FILTER_VALUES.page,
      orderBy: formValue.sortBy || undefined,
      order: formValue.sortDirection === "desc" ? "desc" : "asc",

      // Date ranges
      ...this.extractDateRangeFilters(formValue),

      // Additional parameters to match old QMC behavior
      offset: this.currentSite()?.UtcOffset || -5, // Use site UTC offset or default to -5 like old QMC
      active: true, // Always include active orders
      valid: true, // Always include valid orders
    };

    return filter;
  }

  /**
   * Extract date range filters from form values
   */
  private extractDateRangeFilters(
    formValue: Partial<{
      customerCreatedRange: Date[] | null;
      scheduledOrderCreatedRange: Date[] | null;
      nextOccurrenceRange: Date[] | null;
      lastProcessedRange: Date[] | null;
    }>,
  ): Partial<ScheduledOrdersFilter> {
    const dateFilters: Partial<ScheduledOrdersFilter> = {};

    // Helper to normalize date range (handles both DateRange object and Date array from PrimeNG)
    // Also normalizes times: start dates to 00:00:00, end dates to 23:59:59
    const normalizeDateRange = (
      range: DateRange | Date[] | null,
    ): { start: Date; end: Date } | null => {
      if (!range) return null;

      let startDate: Date | null = null;
      let endDate: Date | null = null;

      // Handle DateRange object format
      if (
        typeof range === "object" &&
        "startDate" in range &&
        range.startDate
      ) {
        // Require BOTH start and end dates for range filter
        if (!range.endDate) return null;
        startDate = range.startDate;
        endDate = range.endDate;
      }
      // Handle Date array format from PrimeNG datepicker (range mode)
      else if (Array.isArray(range) && range.length > 0 && range[0]) {
        // If only start date is selected (range[1] is null/undefined), return null to prevent search
        if (!range[1]) return null;
        startDate = range[0];
        endDate = range[1];
      }

      if (!startDate || !endDate) return null;

      // Normalize times to match old QMC behavior:
      // Start date: 00:00:00.000 (beginning of day)
      // End date: 23:59:59.999 (end of day)
      const normalizedStart = new Date(startDate);
      normalizedStart.setHours(0, 0, 0, 0);

      const normalizedEnd = new Date(endDate);
      normalizedEnd.setHours(23, 59, 59, 999);

      return {
        start: normalizedStart,
        end: normalizedEnd,
      };
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    const customerRange = normalizeDateRange(
      formValue.customerCreatedRange as any,
    );
    if (customerRange) {
      dateFilters.customerCreatedFromDate = customerRange.start;
      dateFilters.customerCreatedToDate = customerRange.end;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    const scheduledOrderRange = normalizeDateRange(
      formValue.scheduledOrderCreatedRange as any,
    );
    if (scheduledOrderRange) {
      dateFilters.scheduledOrderCreatedFromDate = scheduledOrderRange.start;
      dateFilters.scheduledOrderCreatedToDate = scheduledOrderRange.end;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    const nextOccurrenceRange = normalizeDateRange(
      formValue.nextOccurrenceRange as any,
    );
    if (nextOccurrenceRange) {
      dateFilters.startDate = nextOccurrenceRange.start;
      dateFilters.endDate = nextOccurrenceRange.end;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    const lastProcessedRange = normalizeDateRange(
      formValue.lastProcessedRange as any,
    );
    if (lastProcessedRange) {
      dateFilters.lastProcessedFromDate = lastProcessedRange.start;
      dateFilters.lastProcessedToDate = lastProcessedRange.end;
    }

    return dateFilters;
  }

  /**
   * Handle filter changes from child component
   */
  onFiltersChanged(filter: ScheduledOrdersFilter): void {
    // This is handled automatically by the form valueChanges subscription
    // Child component updates the form, which triggers data reload
    // Reset to first page when filters change (not pagination)
    this.filterForm.patchValue({ page: 1 }, { emitEvent: false });
  }

  /**
   * Handle clear filters from child component
   * Clears ALL filters including status (sets to empty array)
   * Defaults are only applied on initial page load, not when clearing
   */
  onClearFilters(): void {
    // Reset form but keep siteId and pagination defaults
    // Clear ALL filters including status - defaults only apply on page load
    this.filterForm.patchValue({
      search: null,
      status: [] as ScheduledOrderStatus[],
      processingErrorCodes: [],
      customerCreatedRange: null,
      scheduledOrderCreatedRange: null,
      nextOccurrenceRange: null,
      page: DEFAULT_FILTER_VALUES.page,
      pageSize: DEFAULT_FILTER_VALUES.pageSize,
      sortBy: DEFAULT_FILTER_VALUES.sortBy,
      sortDirection: DEFAULT_FILTER_VALUES.sortDirection,
    });

    // Clear persisted filters so they don't reload on next visit
    localStorage.removeItem("scheduledOrders.filters");
  }

  /**
   * Handle table sorting
   */
  onSortChanged(event: SortEvent): void {
    this.filterForm.patchValue({
      sortBy: event.field,
      sortDirection: event.order === 1 ? "asc" : "desc",
      page: 1, // Reset to first page
    });
  }

  /**
   * Handle table pagination
   */
  onPageChanged(event: PageEvent): void {
    // Calculate page number from first index if page is undefined
    const currentPage =
      event.page !== undefined
        ? event.page
        : Math.floor(event.first / event.rows);

    this.filterForm.patchValue({
      page: currentPage + 1, // PrimeNG uses 0-based pages, API uses 1-based
      pageSize: event.rows,
    });
  }

  /**
   * Handle table selection changes
   */
  onSelectionChanged(selectedItems: ScheduledOrderListItem[]): void {
    this.selectedOrders.set(selectedItems);
  }

  /**
   * Check if all items on the current page are selected
   */
  isAllSelected(): boolean {
    const items = this.data()?.Items || [];
    return items.length > 0 && this.selectedItems().length === items.length;
  }

  /**
   * Check if some (but not all) items are selected
   */
  isSomeSelected(): boolean {
    const items = this.data()?.Items || [];
    const selected = this.selectedItems().length;
    return selected > 0 && selected < items.length;
  }

  /**
   * Toggle selection of all items on the current page
   */
  toggleSelectAll(): void {
    const items = this.data()?.Items || [];
    if (this.isAllSelected()) {
      // Deselect all
      this.selectedOrders.set([]);
    } else {
      // Select all
      this.selectedOrders.set([...items]);
    }
  }

  /**
   * Handle individual row actions
   */
  onRowAction(event: { action: string; item: ScheduledOrderListItem }): void {
    const { action, item } = event;

    switch (action) {
      case "view":
        this.viewOrderDetails(item);
        break;
      case "edit":
        this.editOrder(item);
        break;
      case "delete":
        this.deleteOrder(item);
        break;
      case "activate":
        this.activateOrder(item);
        break;
      case "pause":
        this.pauseOrder(item);
        break;
      case "retry":
        this.retryOrder(item);
        break;
      case "retryUpdate":
        this.retryUpdateOrder(item);
        break;
      case "processNow":
        this.processOrderNow(item);
        break;
      case "viewHistory":
        this.viewProcessingHistory(item);
        break;
      case "viewCycles":
        this.viewProcessingCycles(item);
        break;
      case "reschedule":
        this.openRescheduleDialog(item);
        break;
      default:
        console.warn("Unknown row action:", action);
    }
  }

  // Individual order actions

  /**
   * Navigate to order (create or edit)
   * Handles both embedded mode (emits events) and standard mode (uses router)
   */
  private navigateToOrder(
    orderId: number | null,
    action: "edit" | "create",
  ): void {
    const siteId = this.currentSiteId();
    if (!siteId) return;

    if (this.embeddedMode) {
      // Emit event for parent application to handle
      const event = new CustomEvent("qmc-navigate", {
        detail: {
          component: "scheduled-order",
          action: action,
          orderId: orderId,
          siteId: siteId,
        },
        bubbles: true,
        composed: true,
      });
      this.elementRef.nativeElement.dispatchEvent(event);
    } else {
      // Use standard routing
      if (action === "create") {
        this.router.navigate([
          "/widgets",
          "dashboard",
          siteId,
          "scheduled-orders",
          "new",
        ]);
      } else {
        this.router.navigate([
          "/widgets",
          "dashboard",
          siteId,
          "scheduled-orders",
          orderId,
          "edit",
        ]);
      }
    }
  }

  private viewOrderDetails(item: ScheduledOrderListItem): void {
    // View redirects to edit page (matching old QMC behavior)
    this.navigateToOrder(item.Id, "edit");
  }

  private editOrder(item: ScheduledOrderListItem): void {
    this.navigateToOrder(item.Id, "edit");
  }

  private deleteOrder(item: ScheduledOrderListItem): void {
    this.confirmationService.confirm({
      message: `Are you sure you want to cancel/delete scheduled order #${item.Id}? This action cannot be undone.`,
      header: "Confirm Cancel/Delete",
      icon: "pi pi-exclamation-triangle",
      acceptIcon: "pi pi-times",
      acceptButtonStyleClass: "p-button-danger",
      acceptLabel: "Yes, cancel/delete it",
      rejectLabel: "No, keep it",
      accept: () => {
        const accessToken = this.getAccessToken();
        if (!accessToken) return;

        this.qpilotService
          .deleteScheduledOrder(this.currentSiteId()!, item.Id, accessToken)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: () => {
              this.messageService.add({
                severity: "success",
                summary: "Success",
                detail: "Scheduled order cancelled/deleted successfully",
              });
              this.refreshData();
            },
          });
      },
    });
  }

  private activateOrder(item: ScheduledOrderListItem): void {
    this.confirmationService.confirm({
      message: `Are you sure you want to activate scheduled order #${item.Id}?`,
      header: "Confirm Activate",
      icon: "pi pi-exclamation-triangle",
      acceptIcon: "pi pi-check",
      acceptButtonStyleClass: "p-button-success",
      acceptLabel: "Yes, activate it",
      rejectLabel: "Cancel",
      accept: () => {
        const accessToken = this.getAccessToken();
        if (!accessToken) return;

        this.qpilotService
          .activateScheduledOrder(this.currentSiteId()!, item.Id, accessToken)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: () => {
              this.messageService.add({
                severity: "success",
                summary: "Success",
                detail: "Scheduled order activated successfully",
              });
              this.refreshData();
            },
          });
      },
    });
  }

  private pauseOrder(item: ScheduledOrderListItem): void {
    this.confirmationService.confirm({
      message: `Are you sure you want to pause scheduled order #${item.Id}?`,
      header: "Confirm Pause",
      icon: "pi pi-exclamation-triangle",
      acceptIcon: "pi pi-pause",
      acceptButtonStyleClass: "p-button-warning",
      acceptLabel: "Yes, pause it",
      rejectLabel: "Cancel",
      accept: () => {
        const accessToken = this.getAccessToken();
        if (!accessToken) return;

        this.qpilotService
          .bulkUpdateStatus(
            this.currentSiteId()!,
            [item.Id],
            "Paused",
            accessToken,
          )
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: () => {
              this.messageService.add({
                severity: "success",
                summary: "Success",
                detail: "Scheduled order paused successfully",
              });
              this.refreshData();
            },
          });
      },
    });
  }

  private retryOrder(item: ScheduledOrderListItem): void {
    // Add upfront confirmation before retry (matches V2 portal pattern)
    this.confirmationService.confirm({
      message: `Are you sure you want to restart processing for scheduled order #${item.Id}?`,
      header: "Confirm Restart Processing",
      icon: "pi pi-exclamation-triangle",
      acceptIcon: "pi pi-refresh",
      acceptButtonStyleClass: "p-button-success",
      acceptLabel: "Yes, restart it",
      rejectLabel: "Cancel",
      accept: () => {
        const accessToken = this.getAccessToken();
        if (!accessToken) return;

        // Run pre-validation before retrying (matches old QMC workflow)

        this.qpilotService
          .updateScheduledOrderPreValidationResult(
            this.currentSiteId()!,
            item.Id,
            accessToken,
          )
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (validationResult) => {
              if (validationResult.Succeeded) {
                // Validation passed - proceed with retry
                this.executeRetryOrder(item);
              } else {
                // Validation failed - show validation dialog
                this.openValidationDialogForRetry(item, validationResult);
              }
            },
            error: (error) => {
              console.error("Pre-validation failed:", error);
              this.messageService.add({
                severity: "error",
                summary: "Validation Error",
                detail: "Failed to validate scheduled order. Please try again.",
                life: 5000,
              });
            },
          });
      },
    });
  }

  /**
   * Execute retry order after validation passes
   */
  private executeRetryOrder(item: ScheduledOrderListItem): void {
    const accessToken = this.getAccessToken();
    if (!accessToken) return;

    this.qpilotService
      .retryScheduledOrder(this.currentSiteId()!, item.Id, accessToken)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Scheduled order has restarted processing",
          });
          this.refreshData();
        },
        error: (error) => {
          console.error("Retry failed:", error);
          this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: "Failed to retry scheduled order. Please try again.",
            life: 5000,
          });
        },
      });
  }

  /**
   * Open validation dialog when retry validation fails
   */
  private openValidationDialogForRetry(
    item: ScheduledOrderListItem,
    validationResult: ValidationResult,
  ): void {
    if (!this.currentSite()) return;

    // Update item with validation result
    const updatedItem = { ...item, ValidationChecks: validationResult };

    const ref = this.dialogService.open(ValidationChecksDialogComponent, {
      header: `Validation Checks - Order #${item.Id}`,
      width: "700px",
      modal: true,
      closable: true,
      closeOnEscape: true,
      dismissableMask: false,
      breakpoints: {
        "960px": "90vw",
        "640px": "95vw",
      },
      data: {
        scheduledOrder: updatedItem,
        site: this.currentSite(),
        dontPersistPreValidationRefresh: false,
        accessToken: this.getAccessToken(), // Pass access token for embedded mode
      },
    });

    ref.onClose.subscribe((result: ScheduledOrderListItem) => {
      if (result) {
        // Refresh data if validation was updated
        this.refreshData();
      }
    });
  }

  private retryUpdateOrder(item: ScheduledOrderListItem): void {
    // Add confirmation before retry (matches V2 portal pattern)
    this.confirmationService.confirm({
      message: `Are you sure you want to restart processing for scheduled order #${item.Id}?`,
      header: "Confirm Restart Processing",
      icon: "pi pi-exclamation-triangle",
      acceptIcon: "pi pi-refresh",
      acceptButtonStyleClass: "p-button-success",
      acceptLabel: "Yes, restart it",
      rejectLabel: "Cancel",
      accept: () => {
        const accessToken = this.getAccessToken();
        if (!accessToken) return;

        this.qpilotService
          .retryUpdateOrder(this.currentSiteId()!, item.Id, accessToken)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: () => {
              this.messageService.add({
                severity: "success",
                summary: "Success",
                detail: "Order update retry initiated",
              });
            },
          });
      },
    });
  }

  /**
   * Open reschedule dialog to change the next occurrence date
   * Matches Portal V2 reschedule-order functionality
   */
  private openRescheduleDialog(item: ScheduledOrderListItem): void {
    const siteId = this.currentSiteId();
    if (!siteId) return;

    const isMobile = window.innerWidth < 768;

    const dialogRef = this.dialogService.open(RescheduleDialogComponent, {
      header: `Reschedule Order #${item.Id}`,
      width: isMobile ? "95vw" : "450px",
      modal: true,
      closable: true,
      closeOnEscape: true,
      dismissableMask: true,
      focusOnShow: false,
      styleClass: "reschedule-dialog-container",
      breakpoints: {
        "768px": "95vw",
      },
      data: {
        orderId: item.Id,
        siteId: siteId,
        currentNextOccurrenceUtc: item.NextOccurrenceUtc,
        utcOffset: item.UtcOffset,
        frequency: item.Frequency,
        frequencyType: item.FrequencyType,
        resumeAfter: item.Status === "Paused", // Auto-resume paused orders
        inputToken: this.getAccessToken(), // Support embedded mode
      },
    });

    dialogRef.onClose.subscribe(
      (result: RescheduleDialogResult | undefined) => {
        if (result?.success) {
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Next order date updated successfully",
          });
          this.refreshData();
        }
      },
    );
  }

  private processOrderNow(item: ScheduledOrderListItem): void {
    // Add upfront confirmation before validation (matches V2 portal pattern)
    this.confirmationService.confirm({
      message: `Are you sure you want to process scheduled order #${item.Id} now?`,
      header: "Confirm Process Now",
      icon: "pi pi-exclamation-triangle",
      acceptIcon: "pi pi-play",
      acceptButtonStyleClass: "p-button-success",
      acceptLabel: "Yes, process it now",
      rejectLabel: "Cancel",
      accept: () => {
        const accessToken = this.getAccessToken();
        if (!accessToken) return;

        // Run pre-validation before processing (matches old QMC workflow)

        this.qpilotService
          .updateScheduledOrderPreValidationResult(
            this.currentSiteId()!,
            item.Id,
            accessToken,
          )
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (validationResult) => {
              if (validationResult.Succeeded) {
                // Check if order was recently processed (IsInRepeatTimeWindow)
                // Old QMC shows confirmation dialog if true
                if (validationResult.IsInRepeatTimeWindow) {
                  this.showRepeatProcessingConfirmation(item);
                } else {
                  // Validation passed and not in repeat window - proceed directly
                  this.executeProcessOrderNow(item);
                }
              } else {
                // Validation failed - show validation dialog
                this.openValidationDialogForRetry(item, validationResult);
              }
            },
            error: (error) => {
              console.error("Pre-validation failed:", error);
              this.messageService.add({
                severity: "error",
                summary: "Validation Error",
                detail: "Failed to validate scheduled order. Please try again.",
                life: 5000,
              });
            },
          });
      },
    });
  }

  /**
   * Show confirmation dialog when order was recently processed
   * Matches old QMC buildRepeatProcessingConfirmationDialog
   */
  private showRepeatProcessingConfirmation(item: ScheduledOrderListItem): void {
    const lastOccurrence = item.LastOccurrenceUtc
      ? new Date(item.LastOccurrenceUtc)
      : null;
    const timeAgo = lastOccurrence
      ? this.formatTimeAgo(lastOccurrence)
      : "recently";

    this.confirmationService.confirm({
      message: `This Scheduled Order processed ${timeAgo}. Are you sure you want to process it again?`,
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Yes, process it again",
      rejectLabel: "Cancel",
      accept: () => {
        this.executeProcessOrderNow(item);
      },
    });
  }

  /**
   * Execute process order now after validation passes
   * Matches old QMC retryScheduledOrder workflow with double validation
   */
  private executeProcessOrderNow(item: ScheduledOrderListItem): void {
    const accessToken = this.getAccessToken();
    if (!accessToken) return;

    // OLD QMC PATTERN: Validate AGAIN before calling API (matches old QMC retryScheduledOrder line 293)
    this.qpilotService
      .updateScheduledOrderPreValidationResult(
        this.currentSiteId()!,
        item.Id,
        accessToken,
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (validationResult) => {
          if (validationResult.Succeeded) {
            // Second validation passed - proceed with retry API call
            this.qpilotService
              .retryScheduledOrder(this.currentSiteId()!, item.Id, accessToken)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: () => {
                  this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Scheduled Order has restarted processing",
                  });
                  this.refreshData();
                },
                error: (error) => {
                  console.error("Process failed:", error);
                  this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail:
                      "Failed to process scheduled order. Please try again.",
                    life: 5000,
                  });
                },
              });
          } else {
            // Second validation failed - show validation dialog
            this.openValidationDialogForRetry(item, validationResult);
          }
        },
        error: (error) => {
          console.error("Second pre-validation failed:", error);
          this.messageService.add({
            severity: "error",
            summary: "Validation Error",
            detail: "Failed to validate scheduled order. Please try again.",
            life: 5000,
          });
        },
      });
  }

  /**
   * Format time ago (simple implementation matching old QMC timeAgoPipe)
   */
  private formatTimeAgo(date: Date): string {
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffMins < 1) return "just now";
    if (diffMins < 60)
      return `${diffMins} minute${diffMins !== 1 ? "s" : ""} ago`;
    if (diffHours < 24)
      return `${diffHours} hour${diffHours !== 1 ? "s" : ""} ago`;
    return `${diffDays} day${diffDays !== 1 ? "s" : ""} ago`;
  }

  private viewProcessingHistory(_item: ScheduledOrderListItem): void {
    // Navigate to processing history (placeholder - implement based on routing structure)
  }

  private viewProcessingCycles(item: ScheduledOrderListItem): void {
    // Open the processing cycles dialog (matches old QMC pattern)
    // Use responsive width for mobile devices
    const isMobile = window.innerWidth <= 768;
    this.cyclesDialogRef = this.dialogService.open(
      ScheduledOrderCyclesDialogComponent,
      {
        header: "Processing Cycles History",
        width: isMobile ? "95vw" : "80vw",
        height: isMobile ? "85vh" : "70vh",
        contentStyle: {
          overflow: "auto",
          padding: isMobile ? "0.75rem" : "1rem",
        },
        baseZIndex: 10000,
        maximizable: true,
        dismissableMask: true,
        data: {
          scheduledOrderId: item.Id,
          siteId: this.currentSiteId()!,
          scheduledOrder: item,
          embeddedMode: this.embeddedMode, // Pass embedded mode to dialog
          accessToken: this.getAccessToken(), // Pass access token for embedded mode
        },
      },
    );

    // Listen for navigation events from dialog (for embedded mode)
    if (this.cyclesDialogRef.onClose) {
      this.cyclesDialogRef.onClose.subscribe((result: any) => {
        if (
          result?.action === "navigate-to-cycle" &&
          result.processingCycleId
        ) {
          this.goToProcessingCycleView(
            result.processingCycleId,
            result.scheduledOrderId,
          );
        }
      });
    }
  }

  /**
   * Navigate to processing cycle view (dual mode: embedded vs standard)
   */
  private goToProcessingCycleView(
    processingCycleId: number,
    scheduledOrderId: number,
  ): void {
    if (!scheduledOrderId || !processingCycleId) {
      console.error("Missing required IDs for navigation:", {
        scheduledOrderId,
        processingCycleId,
      });
      return;
    }

    if (this.embeddedMode) {
      // Embedded mode: emit navigation event
      const event = new CustomEvent("qmc-navigate-to-cycle", {
        detail: {
          component: "scheduled-orders-list",
          targetComponent: "processing-cycle-view",
          siteId: this.currentSiteId(),
          scheduledOrderId: scheduledOrderId,
          processingCycleId: processingCycleId,
        },
        bubbles: true,
        composed: true,
      });
      this.elementRef.nativeElement.dispatchEvent(event);
    } else {
      // Standard mode: use Angular Router
      void this.router.navigate([
        "/widgets",
        "dashboard",
        this.currentSiteId(),
        "scheduled-orders",
        scheduledOrderId,
        "edit",
        "processing-cycles",
        processingCycleId,
      ]);
    }
  }

  /**
   * Handle navigate to cycle event from table component
   * Called when user clicks "View" in Processing Cycles History dialog
   */
  onNavigateToCycle(event: {
    processingCycleId: number;
    scheduledOrderId: number;
    siteId: number;
  }): void {
    this.goToProcessingCycleView(
      event.processingCycleId,
      event.scheduledOrderId,
    );
  }

  // Bulk operations

  private handleBulkActivate(): void {
    const selectedCount = this.selectedOrders().length;
    if (selectedCount === 0) return;

    // Show confirmation dialog (same as update status flow but with Active pre-selected)
    this.confirmationService.confirm({
      message: `Are you sure you want to update the status to "Active" on ${selectedCount} scheduled order${selectedCount !== 1 ? "s" : ""}?`,
      header: "Confirm Status Update",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.executeBulkStatusUpdate("Active", true);
      },
    });
  }

  private handleBulkPause(): void {
    const accessToken = this.getAccessToken();
    if (!accessToken) return;

    const selectedIds = this.selectedOrders().map((order) => order.Id);
    this.isBulkOperationLoading.set(true);

    this.qpilotService
      .bulkUpdateStatus(
        this.currentSiteId()!,
        selectedIds,
        "Paused",
        accessToken,
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (results) => {
          this.handleBulkOperationResponse("Update Status To Paused", results);
        },
        error: () => {
          this.isBulkOperationLoading.set(false);
        },
      });
  }

  private handleBulkProcess(): void {
    const accessToken = this.getAccessToken();
    if (!accessToken) return;

    const selectedIds = this.selectedOrders().map((order) => order.Id);
    this.isBulkOperationLoading.set(true);

    this.qpilotService
      .bulkProcessingOrders(this.currentSiteId()!, selectedIds, accessToken)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (results) => {
          this.handleBulkOperationResponse(
            "Send Scheduled Orders to Processing",
            results,
          );
        },
        error: () => {
          this.isBulkOperationLoading.set(false);
        },
      });
  }

  private handleBulkDelete(): void {
    const selectedCount = this.selectedOrders().length;

    this.confirmationService.confirm({
      message: `Are you sure you want to delete ${selectedCount} selected scheduled order${selectedCount !== 1 ? "s" : ""}?`,
      header: "Confirm Bulk Delete",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        const selectedIds = this.selectedOrders().map((order) => order.Id);
        this.isBulkOperationLoading.set(true);

        // Delete orders one by one (API doesn't support bulk delete)
        const accessToken = this.getAccessToken();
        if (!accessToken) return;

        const deletePromises = selectedIds.map((id) =>
          this.qpilotService
            .deleteScheduledOrder(this.currentSiteId()!, id, accessToken)
            .toPromise(),
        );

        Promise.allSettled(deletePromises)
          .then((results) => {
            // Convert Promise.allSettled results to BulkSOActionsResponse format
            const bulkResults: BulkSOActionsResponse[] = selectedIds.map(
              (id, index) => ({
                ScheduledOrderId: id,
                Failed: results[index].status === "rejected",
                Message:
                  results[index].status === "fulfilled"
                    ? "Order deleted successfully"
                    : `Failed to delete order: ${results[index].reason}`,
              }),
            );

            this.handleBulkOperationResponse(
              "Delete Scheduled Orders",
              bulkResults,
            );
          })
          .catch(() => {
            this.isBulkOperationLoading.set(false);
          });
      },
    });
  }

  /**
   * Handle bulk action events from toolbar
   */
  onBulkAction(event: BulkActionEvent): void {
    switch (event.action) {
      case "export":
        this.onExport();
        break;
      case "activate":
        this.handleBulkActivate();
        break;
      case "updateStatus":
        this.handleBulkUpdateStatus();
        break;
      case "startProcessing":
        this.handleBulkStartProcessing();
        break;
      default:
        console.warn("Unknown bulk action:", event.action);
    }
  }

  /**
   * Export scheduled orders
   */
  onExport(): void {
    const accessToken = this.getAccessToken();
    if (!accessToken) return;

    const filter = this.buildFilterFromForm(this.filterForm.value);

    this.qpilotService
      .exportScheduledOrders(filter, accessToken)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (csvData) => {
          // Create and trigger download
          const blob = new Blob([csvData], { type: "text/csv" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `scheduled-orders-${new Date().toISOString().split("T")[0]}.csv`;
          link.click();
          window.URL.revokeObjectURL(url);

          this.messageService.add({
            severity: "success",
            summary: "Export Complete",
            detail: "Scheduled orders exported successfully",
          });
        },
      });
  }

  /**
   * Handle bulk update status with status selection dialog
   */
  private handleBulkUpdateStatus(): void {
    const selectedCount = this.selectedOrders().length;
    if (selectedCount === 0) return;

    const dialogRef = this.dialogService.open(StatusSelectionDialogComponent, {
      header: "Update Status on Scheduled Orders",
      width: "500px",
      breakpoints: {
        "576px": "95vw",
      },
      modal: true,
      closable: true,
      data: {
        selectedCount,
      },
    });

    dialogRef.onClose.subscribe((result: StatusSelectionResult | null) => {
      if (result) {
        this.confirmationService.confirm({
          message: `Are you sure you want to update the status to "${result.status}" on ${result.selectedCount} scheduled order${result.selectedCount !== 1 ? "s" : ""}?`,
          header: "Confirm Status Update",
          icon: "pi pi-exclamation-triangle",
          accept: () => {
            this.executeBulkStatusUpdate(result.status, true);
          },
        });
      }
    });
  }

  /**
   * Execute bulk status update
   */
  private executeBulkStatusUpdate(
    status: string,
    showGlobalLoader = false,
  ): void {
    const accessToken = this.getAccessToken();
    if (!accessToken) return;

    const selectedIds = this.selectedOrders().map((order) => order.Id);
    this.isBulkOperationLoading.set(true);

    this.qpilotService
      .bulkUpdateStatus(
        this.currentSiteId()!,
        selectedIds,
        status,
        accessToken,
        showGlobalLoader,
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (results) => {
          this.handleBulkOperationResponse(
            `Update Status To ${status}`,
            results,
            showGlobalLoader,
          );
        },
        error: () => {
          this.isBulkOperationLoading.set(false);
        },
      });
  }

  /**
   * Handle bulk start processing with pre-validation (matches old QMC)
   */
  private handleBulkStartProcessing(): void {
    const selectedOrders = this.selectedOrders();
    if (selectedOrders.length === 0) return;

    this.isBulkOperationLoading.set(true);

    // Implement pre-validation logic matching old QMC bulkPrevalidation function
    this.performBulkPreValidation(selectedOrders)
      .then((preFailedBulkSoActions) => {
        this.isBulkOperationLoading.set(false);

        // Filter to get only orders that passed validation (not in failed list)
        const validatedOrders = selectedOrders.filter(
          (order) =>
            !preFailedBulkSoActions.find(
              (failed) => failed.ScheduledOrderId === order.Id,
            ),
        );

        const validCount = validatedOrders.length;

        // Show confirmation dialog - include all selected orders (even if pre-validation failed)
        const confirmMessage = `Are you sure you want to Start processing ${
          selectedOrders.length === 1
            ? "that Scheduled Order"
            : `these ${selectedOrders.length} Scheduled Orders`
        }?`;

        this.confirmationService.confirm({
          message: confirmMessage,
          header: "Start Processing",
          icon: "pi pi-exclamation-triangle",
          accept: () => {
            this.isBulkOperationLoading.set(true);
            // Send ALL selected order IDs (including deleted ones) to the API
            // The API will handle them and return appropriate responses
            this.executeBulkProcessingWithFailures(
              selectedOrders.map((o) => o.Id),
              preFailedBulkSoActions,
            );
          },
        });
      })
      .catch((error) => {
        console.error("Bulk pre-validation failed:", error);
        this.messageService.add({
          severity: "error",
          summary: "Validation Error",
          detail: "Failed to validate scheduled orders. Please try again.",
          life: 5000,
        });
        this.isBulkOperationLoading.set(false);
      });
  }

  /**
   * Execute bulk processing
   */
  private executeBulkProcessing(orderIds: number[]): void {
    const accessToken = this.getAccessToken();
    if (!accessToken) return;

    this.qpilotService
      .bulkProcessingOrders(this.currentSiteId()!, orderIds, accessToken)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (results) => {
          this.handleBulkOperationResponse(
            "Send Scheduled Orders to Processing",
            results,
          );
        },
        error: () => {
          this.isBulkOperationLoading.set(false);
        },
      });
  }

  /**
   * Execute bulk processing with pre-validation failures
   * Note: Only shows API results in dialog, NOT pre-validation failures (matches old QMC)
   */
  private executeBulkProcessingWithFailures(
    orderIds: number[],
    preFailedBulkSoActions: BulkSOActionsResponse[],
  ): void {
    const accessToken = this.getAccessToken();
    if (!accessToken) return;

    this.qpilotService
      .bulkProcessingOrders(this.currentSiteId()!, orderIds, accessToken, true) // Show global loader
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (processingResults) => {
          // Only show API processing results (matches old QMC behavior)
          // Pre-validation failures are NOT shown in the results dialog
          this.handleBulkOperationResponse(
            "Send Scheduled Orders to Processing",
            processingResults, // Only API results, no pre-validation failures
          );
        },
        error: () => {
          this.isBulkOperationLoading.set(false);
        },
      });
  }

  /**
   * Handle bulk operation response with detailed dialog (matches old QMC)
   */
  private handleBulkOperationResponse(
    operationName: string,
    results: BulkSOActionsResponse[],
    hideGlobalLoader = false,
  ): void {
    this.isBulkOperationLoading.set(false);

    // Convert BulkSOActionsResponse to BulkActionsResponse format
    const convertedResults: BulkActionsResponse[] = results.map((result) => ({
      ScheduledOrderId: result.ScheduledOrderId,
      Failed: result.Failed,
      Message:
        result.Message ||
        (result.Failed
          ? "Operation failed"
          : "Operation completed successfully"),
    }));

    const dialogData: BulkDetailedResponseDialogData = {
      title: "Bulk Actions - Detailed Response",
      message: operationName,
      siteId: this.currentSiteId()!,
      response: convertedResults,
    };

    this.dialogService.open(BulkDetailedResponseDialogComponent, {
      header: "Bulk Operation Results",
      width: "850px",
      breakpoints: {
        "576px": "95vw",
      },
      modal: true,
      maximizable: true,
      closable: true,
      closeOnEscape: true,
      data: dialogData,
    });

    // Refresh data after bulk operation
    this.refreshData();
  }

  /**
   * Refresh data by re-triggering form changes
   */
  private refreshData(): void {
    this.filterForm.markAsDirty();
    this.filterForm.updateValueAndValidity();
  }

  /**
   * Navigate to create new scheduled order
   * Only available for non-Shopify sites
   */
  onCreateNew(): void {
    if (this.isShopifySite()) {
      this.messageService.add({
        severity: "warn",
        summary: "Not Available",
        detail: "Creating scheduled orders is not available for Shopify sites.",
        life: 5000,
      });
      return;
    }

    this.navigateToOrder(null, "create");
  }

  /**
   * Toggle drawer visibility
   */
  toggleSidebar(): void {
    const newState = !this.sidebarCollapsed();
    this.sidebarCollapsed.set(newState);
    this.userManuallyCollapsed = newState; // Track user preference
  }

  /**
   * Initialize sidebar state based on screen size
   */
  private initializeResponsiveSidebar(): void {
    const isMobile = window.innerWidth <= 768;
    this.sidebarCollapsed.set(isMobile);
  }

  /**
   * Setup window resize listener for responsive behavior
   */
  private setupWindowResizeListener(): void {
    const resizeObserver = new ResizeObserver(() => {
      const isMobile = window.innerWidth <= 768;

      // Only auto-collapse on mobile if user hasn't manually set preference
      if (isMobile && !this.userManuallyCollapsed) {
        this.sidebarCollapsed.set(true);
      } else if (!isMobile && !this.userManuallyCollapsed) {
        // Only auto-expand on desktop if user hasn't manually collapsed
        this.sidebarCollapsed.set(false);
      }
      // If user manually toggled, respect their preference regardless of screen size

      this.cdr.markForCheck();
    });

    // Observe the window for resize changes
    resizeObserver.observe(document.body);

    // Clean up observer on destroy
    this.destroy$.subscribe(() => {
      resizeObserver.disconnect();
    });
  }

  /**
   * Perform bulk pre-validation for selected orders (matches old QMC bulkPrevalidation function)
   * @param selectedOrders Array of selected scheduled orders
   * @returns Promise with ONLY FAILED validations as BulkSOActionsResponse[]
   */
  private async performBulkPreValidation(
    selectedOrders: ScheduledOrderListItem[],
  ): Promise<BulkSOActionsResponse[]> {
    const accessToken = this.getAccessToken();
    if (!accessToken) {
      throw new Error("No access token available");
    }

    const siteId = this.currentSiteId();
    if (!siteId) {
      throw new Error("No site ID available");
    }

    // Run validation for all selected orders in parallel
    const validationPromises = selectedOrders.map((order) =>
      this.qpilotService
        .updateScheduledOrderPreValidationResult(
          siteId,
          order.Id,
          accessToken,
          true, // Show global loader during pre-validation
        )
        .toPromise(),
    );

    try {
      const results = await Promise.allSettled(validationPromises);
      const preFailedBulkSoActions: BulkSOActionsResponse[] = [];

      // Convert to BulkSOActionsResponse and collect ONLY failures (matches old QMC)
      results.forEach((result, index) => {
        const order = selectedOrders[index];

        if (result.status === "fulfilled" && result.value) {
          // If validation succeeded is false, add to failed list
          if (!result.value.Succeeded) {
            const failedAction: BulkSOActionsResponse = {
              ScheduledOrderId: order.Id,
              Failed: true,
              Message: this.formatValidationErrorMessage(result.value),
            };
            preFailedBulkSoActions.push(failedAction);
          }
        } else {
          // API call failed - treat as validation failure
          const failedAction: BulkSOActionsResponse = {
            ScheduledOrderId: order.Id,
            Failed: true,
            Message:
              result.status === "rejected"
                ? `Validation failed: ${result.reason}`
                : "Unknown validation error",
          };
          preFailedBulkSoActions.push(failedAction);
        }
      });

      return preFailedBulkSoActions;
    } catch (error) {
      console.error("Error during bulk pre-validation:", error);
      throw error;
    }
  }

  /**
   * Format validation error message for display
   * @param validationResult The validation result with errors
   * @returns Formatted error message string
   */
  private formatValidationErrorMessage(
    validationResult: ValidationResult,
  ): string {
    if (
      !validationResult.ErrorItems ||
      validationResult.ErrorItems.length === 0
    ) {
      return "Validation failed - no specific errors provided";
    }

    const errors = validationResult.ErrorItems.map(
      (error) =>
        `Error ${error.ProcessingErrorCode}: ${error.ScheduledOrderFailureReason}`,
    ).join("; ");

    return `Validation failed: ${errors}`;
  }

  // ========== Items 8 & 9: Items Count Calculation ==========
  // Calculates Disabled flag using same logic as scheduled-order-form.component.ts

  /**
   * Load items counts for all orders in the list
   * Fetches full order data and counts enabled vs total items
   * Calculates Disabled flag using product properties (same as scheduled-order-form.component.ts)
   */
  private loadEnabledItemsCounts(
    orders: PagedResult<ScheduledOrderListItem>,
  ): void {
    const accessToken = this.getAccessToken();
    if (!accessToken || !orders?.Items?.length) return;

    // Fetch full order data for each order in parallel (without showing global loader)
    const orderRequests = orders.Items.map((order) =>
      this.qpilotService
        .getScheduledOrderFull(order.Id, accessToken, false)
        .pipe(
          catchError(() => of(null)), // Don't fail the whole batch if one fails
        ),
    );

    forkJoin(orderRequests)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (fullOrders) => {
          const countsMap = new Map<
            number,
            { enabled: number; total: number }
          >();

          fullOrders.forEach((fullOrder) => {
            if (!fullOrder || !fullOrder.ScheduledOrderItems) return;

            const orderId = fullOrder.Id as number;
            const items = fullOrder.ScheduledOrderItems || [];

            // Total = number of item lines (not sum of quantities)
            const totalCount = items.length;

            // Calculate enabled count using same logic as scheduled-order-form.component.ts
            // The Disabled flag is NOT returned by API, it's calculated client-side
            const enabledCount = items.filter((item: any) => {
              return !this.isItemDisabled(item);
            }).length;

            countsMap.set(orderId, {
              enabled: enabledCount,
              total: totalCount,
            });
          });

          this.itemsCounts.set(countsMap);
          this.cdr.markForCheck();
        },
        error: (error) => {
          console.error("Error loading items counts:", error);
          // Don't show error to user - just silently fall back to showing total
        },
      });
  }

  /**
   * Check if an item is disabled
   * Replicates logic from scheduled-order-form.component.ts syncScheduledOrderItemsWithForm
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private isItemDisabled(item: any): boolean {
    const product = item?.Product;

    // If no product, item is disabled
    if (!product) {
      return true;
    }

    // Check if product is active (can be processed)
    const isProductActive = this.isProductActiveForList(product);

    // Check if disabled due to backorder restrictions
    const isDisabledForBackorders = this.isDisabledForBackordersList(
      item,
      product,
    );

    return !isProductActive || isDisabledForBackorders;
  }

  /**
   * Check if product is active (can be processed)
   * Matches scheduled-order-form.component.ts isProductActive logic
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private isProductActiveForList(product: any): boolean {
    // Check stock level
    const isInStock =
      product.StockLevel === "Undefined" || product.StockLevel === "InStock";

    // Check if enabled for processing scheduled orders
    const isProcessing =
      product.Availability &&
      product.Availability.indexOf("ProcessScheduledOrder") > -1;

    // Check Active and Valid flags
    const isActive = product.Active === true;
    const isValid = product.Valid === true;

    return isInStock && isProcessing && isActive && isValid;
  }

  /**
   * Check if item is disabled due to backorder restrictions
   * Matches scheduled-order-form.component.ts isDisabledForBackorders logic
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private isDisabledForBackordersList(item: any, product: any): boolean {
    return (
      product.BackordersAllowed != null &&
      !product.BackordersAllowed &&
      product.Stock != null &&
      product.Stock < (item.Quantity ?? 0)
    );
  }
}
